module.exports = __webpack_public_path__ + "static/media/25_tn.abb26027.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/25_tn.jpg
// module id = 163
// module chunks = 0